const HOURS_IN_MILLISECONDS = 60 * 60 * 1000;

export function isSelfieUploadWindowOpen(createdDate, expirationHours, { currentDate = new Date() } = {}) {
  if (expirationHours === undefined || expirationHours === null || expirationHours === '') return true;

  const hours = Number(expirationHours);
  if (!Number.isFinite(hours) || hours < 0 || hours === 0) return true;

  const createdAt = new Date(createdDate).getTime();
  const currentAt = new Date(currentDate).getTime();
  if (!Number.isFinite(createdAt) || !Number.isFinite(currentAt)) return true;

  return createdAt + hours * HOURS_IN_MILLISECONDS > currentAt;
}

export function hasNonStockPhotos(photos = []) {
  return photos.some((photo) => photo?.stock_image_uid === null || photo?.stock_image_uid === undefined);
}
